import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import { CheckPermission } from "../Permissions/CheckPermissions";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";

const AppVersion = (props) => {
  const sortOptions = [
    { id: 1, value: "enabled", label: "Enabled" },
    { id: 2, value: "all", label: "All" },
  ];
  const [sortBy, setSortBy] = useState(sortOptions[0].value);
  const [token, setToken] = useState();
  const [data, setData] = useState([]);
  const [del, setDelete] = useState(false);
  const [successAlert, setSuccesAlert] = useState(false);
  const [ItemForDelete, setItemForDelete] = useState("initialState");
  const [errorAlert, setErrorAlert] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getDGC(token);
  }, []);

  const getDGC = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=appversions&env=production`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log("here come the result data------>", result?.versionsData);
        let obj = result?.versionsData;
        let tempArray = Object.keys(obj).map(k=>({...obj[k], item_type : k}))
        setData(tempArray);
      })
      .catch((error) => console.log(" errror", error));
  };

  const handleConfirmation = () => {
    return (
      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        btnSize="lg"
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          deleteEntry(ItemForDelete?.item_type, token);
          setDelete(false);
        }}
        onCancel={() => setDelete(false)}
        show={true}
      >
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    );
  };
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          props.history.go(0);
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {"App Version deleted successfully."}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {"Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const deleteEntry = (itemType, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=appversions/delete&item_type=${itemType}`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 200) {
          setSuccesAlert(true);
        } else {
          setErrorAlert(true);
        }
        response.text();
      })
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="App Versions" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={6} md={12} sm={12}>
                      <Button
                         disabled={!CheckPermission("appversions","add")}
                        className="btn btn-success waves-effect waves-light"
                        onClick={() => {
                          props?.history?.push("/add-app-version");
                        }}
                      >
                        <FaPlus size={12} /> Add App Version
                      </Button>
                    </Col>
                    <Col lg={6} md={12} sm={12} style={{ textAlign: "right" }}>
                      <div className="mb-3">
                        {/* <Label>Discount Type</Label> */}
                        <label htmlFor="cars">Status</label>
                        <select
                          name="cars"
                          defaultValue={sortOptions[0].value}
                          id="cars"
                          onChange={(e) => {
                            setSortBy(e.target.value);
                          }}
                          style={{ width: 80, height: 30, marginLeft: 10 }}
                          options={sortOptions}
                        >
                          {sortOptions?.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Col>
                  </Row>
                  <div className="table-responsive mt-3">
                    <table
                      style={{}}
                      className="table table-bordered border-primary mb-0"
                    >
                      <thead>
                        <tr>
                          <th>Version Type</th>
                          <th>Title</th>
                          <th>Icon</th>
                          <th>Description</th>
                          <th>Link</th>
                          <th>Version</th>
                          <th>Force Update</th>
                          <th style={{width:"10%"}}>Status</th>
                          <th style={{width:"7%"}}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item, index) => {
                          if (sortBy == "enabled") {
                            if (item?.item_status !== "Y") {
                              return;
                            }
                          }

                          return (
                            <tr key={index}>
                              <td>{item?.item_type}</td>
                              <td>{item?.title}</td>
                              <td><img style={{width:"50px"}} src={item?.icon} alt="" /></td>
                              <td>{item?.description}</td>
                              <td>{item?.link}</td>
                              <td>{item?.version}</td>
                              <td>{item?.force_update.toString()}</td>
                              <td>
                                <Button
                                  color={
                                    item.item_status == "Y"
                                      ? "success"
                                      : "danger"
                                  }
                                >
                                  {item.item_status == "Y"
                                    ? "Enabled"
                                    : "Disabled"}
                                </Button>
                              </td>
                              <td>
                                <Row>
                                  <div className="d-flex justify-content-around">
                                    {CheckPermission("appversions","update") && <div
                                      style={{ width: 30, textAlign: "center" }}
                                      className="text-primary"
                                    >
                                      <a
                                        className="font-size-18"
                                        onClick={() => {
                                          props?.history?.push("/add-app-version", {
                                            edit: true,
                                            item: item,
                                          });
                                        }}
                                      ><FaPen /></a>
                                    </div>}

                                   { CheckPermission("appversions","delete") && <div style={{ width: 30 }}>
                                      <Link to="#" className="px-3 text-danger">
                                        <i
                                          className="font-size-18"
                                          onClick={() => {
                                            setItemForDelete(item);
                                            setDelete(true);
                                          }}
                                        ><FaRegTrashAlt /></i>
                                      </Link>
                                    </div>}
                                  </div>
                                </Row>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {del ? handleConfirmation() : null}
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment> 
  );
};

export default AppVersion;